import React from 'react';
import {PageForm} from '/src/layouts/page';
import ChannelForm from '../../../features/plugins/channels/components/ChannelForm/ChannelForm';
import QuotePart from '/src/components/quote/QuotePart';

function ChannelCreate() {
    return (
        <PageForm>
                <ChannelForm/>
                <QuotePart/>
        </PageForm>

    );
}
export default ChannelCreate;